import React, { useEffect, useState } from "react";
import apiService from "../../services/api.service";

function Layout() {
  const [purchasedCourses, setPurchasedCourses] = useState([]);
  const [userId, setUserId] = useState(localStorage?.getItem("userId"));
  const [userRole, setUserRole] = useState(localStorage?.getItem("userRole"));
  const [chatbotLoaded, setChatbotLoaded] = useState(false);

  useEffect(() => {
    if (userId) {
      const fetchPurchasedCourses = async () => {
        try {
          const response = await apiService.getPurchasedCourses(userId);
          if (response?.data) {
            setPurchasedCourses(response.data);
          }
        } catch (error) {
          console.error("Error fetching purchased courses:", error);
        }
      };
      fetchPurchasedCourses();
    }
  }, [userId]);

  useEffect(() => {
    // Only load chatbot if user is logged in and has purchased courses
    if (
      (userRole === "User" || userRole === "user") &&
      purchasedCourses.length > 0 &&
      !chatbotLoaded
    ) {
      const script = document.createElement("script");
      script.src =
        "https://embed.chatnode.ai/4d9c7906-cb34-4adb-99b9-2e8e6ec83185/popup.js";
      script.async = true;
      script.onload = () => setChatbotLoaded(true);

      document.body.appendChild(script);

      return () => {
        // Cleanup on unmount
        document.body.removeChild(script);
      };
    }
  }, [userRole, purchasedCourses, chatbotLoaded]);

  return <div>{/* Your layout content */}</div>;
}

export default Layout;
